export default __webpack_public_path__ + "static/media/ritovash.49378bfa.jpg";